import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.to-string-tag.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { COOKIE_CURRENCY_OVERRIDE } from "@faire/web--source/common/consts/COOKIE_CURRENCY_OVERRIDE";
import { getCookies } from "@faire/web--source/common/cookies";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { Storage } from "@faire/web--source/common/Storage";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";
import intersection from "lodash/intersection";
import { action, computed, observable } from "mobx";
var CURRENCY_CONFIGURATION_KEY = "CURRENCY_CONFIGURATION_SELECTED_CURRENCY";
var allowedRoles = [UserRole.MAKER, UserRole.MAKER_EDITOR];
/**
 * @deprecated use `useCurrencyStore` or `withStores` instead
 */
export var CurrencyStore = /*#__PURE__*/function () {
  function CurrencyStore() {
    var _this = this;
    _classCallCheck(this, CurrencyStore);
    this.setCurrency = function (currency) {
      if (currency) {
        Storage.local.setItem(CURRENCY_CONFIGURATION_KEY, currency);
      } else {
        Storage.local.removeItem(CURRENCY_CONFIGURATION_KEY);
      }
    };
    this.setConfiguration = function (configuration) {
      _this._configuration = configuration;
    };
    makeObservable(this);
  }
  return _createClass(CurrencyStore, [{
    key: "retailerCurrency",
    get: function get() {
      var _getGlobalProperty;
      return (_getGlobalProperty = getGlobalProperty("retailer")) === null || _getGlobalProperty === void 0 ? void 0 : _getGlobalProperty.currency;
    }
  }, {
    key: "effectiveCurrency",
    get: function get() {
      var _ref3, _ref4, _Storage$local$getIte, _getGlobalProperty4;
      if (this.isBrandPreview) {
        var _ref, _getCookies, _getGlobalProperty2;
        return (_ref = (_getCookies = getCookies(COOKIE_CURRENCY_OVERRIDE)) !== null && _getCookies !== void 0 ? _getCookies : (_getGlobalProperty2 = getGlobalProperty("currencyConversionRate")) === null || _getGlobalProperty2 === void 0 ? void 0 : _getGlobalProperty2.to_currency) !== null && _ref !== void 0 ? _ref : "USD";
      }
      // Only brand preview and legacy Canadian retailers need to use localStorage
      if (!this.retailerCountry || this.retailerCountry !== "CAN" || this.retailerCurrency !== "USD") {
        var _ref2, _this$retailerCurrenc, _getGlobalProperty3;
        return (_ref2 = (_this$retailerCurrenc = this.retailerCurrency) !== null && _this$retailerCurrenc !== void 0 ? _this$retailerCurrenc : (_getGlobalProperty3 = getGlobalProperty("currencyConversionRate")) === null || _getGlobalProperty3 === void 0 ? void 0 : _getGlobalProperty3.to_currency) !== null && _ref2 !== void 0 ? _ref2 : "USD";
      }
      return (_ref3 = (_ref4 = (_Storage$local$getIte = Storage.local.getItem(CURRENCY_CONFIGURATION_KEY)) !== null && _Storage$local$getIte !== void 0 ? _Storage$local$getIte : this.retailerCurrency) !== null && _ref4 !== void 0 ? _ref4 : (_getGlobalProperty4 = getGlobalProperty("currencyConversionRate")) === null || _getGlobalProperty4 === void 0 ? void 0 : _getGlobalProperty4.to_currency) !== null && _ref3 !== void 0 ? _ref3 : "USD";
    }
  }, {
    key: "configuration",
    get: function get() {
      var _this$_configuration;
      return (_this$_configuration = this._configuration) !== null && _this$_configuration !== void 0 ? _this$_configuration : this.defaultConfiguration;
    }
  }, {
    key: "currencyConversions",
    get: function get() {
      return getGlobalProperty("currencyConversionRate");
    }
  }, {
    key: "retailerCountry",
    get: function get() {
      var _getGlobalProperty5;
      return (_getGlobalProperty5 = getGlobalProperty("retailer")) === null || _getGlobalProperty5 === void 0 ? void 0 : _getGlobalProperty5.country;
    }
  }, {
    key: "user",
    get: function get() {
      return getGlobalProperty("user");
    }
  }, {
    key: "isBrandPreview",
    get: function get() {
      var _this$user, _this$user2, _this$user3;
      if (((_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.roles) === null || ((_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.roles) === undefined) {
        return false;
      }
      return intersection(allowedRoles, (_this$user3 = this.user) === null || _this$user3 === void 0 ? void 0 : _this$user3.roles).length > 0;
    }
    /**
     * If the retailer's charged currency is USD we want to allow them to see CAD prices for now
     */
  }, {
    key: "effectiveRetailerCurrency",
    get: function get() {
      var retailerCurrency = this.retailerCurrency;
      if (retailerCurrency === "USD") {
        return undefined;
      }
      return retailerCurrency;
    }
  }, {
    key: "defaultConfiguration",
    get: function get() {
      return {
        selectedCurrency: this.effectiveCurrency,
        currencyConversionRate: this.currencyConversionsRate
      };
    }
  }, {
    key: "currencyConversionsRate",
    get: function get() {
      var currencyConversions = this.currencyConversions,
        effectiveRetailerCurrency = this.effectiveRetailerCurrency;
      if ((currencyConversions === null || currencyConversions === void 0 ? void 0 : currencyConversions.to_currency) === effectiveRetailerCurrency || (currencyConversions === null || currencyConversions === void 0 ? void 0 : currencyConversions.from_currency) === effectiveRetailerCurrency) {
        return currencyConversions;
      }
      return undefined;
    }
  }]);
}();
CurrencyStore.get = singletonGetter(CurrencyStore);
__decorate([observable], CurrencyStore.prototype, "_configuration", void 0);
__decorate([computed], CurrencyStore.prototype, "retailerCurrency", null);
__decorate([computed], CurrencyStore.prototype, "effectiveCurrency", null);
__decorate([computed], CurrencyStore.prototype, "configuration", null);
__decorate([action], CurrencyStore.prototype, "setConfiguration", void 0);
__decorate([computed], CurrencyStore.prototype, "currencyConversions", null);
__decorate([computed], CurrencyStore.prototype, "retailerCountry", null);
__decorate([computed], CurrencyStore.prototype, "user", null);
__decorate([computed], CurrencyStore.prototype, "isBrandPreview", null);
__decorate([computed], CurrencyStore.prototype, "effectiveRetailerCurrency", null);
__decorate([computed], CurrencyStore.prototype, "defaultConfiguration", null);
__decorate([computed], CurrencyStore.prototype, "currencyConversionsRate", null);
export var useCurrencyStore = createStoreHook(CurrencyStore);